export const greyColors = {
  'white': '#FFFFFF',
  'grey-0': '#FFFFFF',
  'grey-25': '#F7F9FA',
  'grey-50': '#F7F9FA',
  'grey-100': '#EDF0F2',
  'grey-200': '#DFE3E8',
  'grey-300': '#CED6DE',
  'grey-400': '#A0AFC0',
  'grey-500': '#7E93AA',
  'grey-600': '#5E7997',
  'grey-700': '#375576',
  'grey-800': '#2A476A',
  'grey-900': '#103051',
  'grey-950' : '#00172E',
}

export const redColors = {
  'red-50': '#FEF5F6',
  'red-100': '#FEE6E7',
  'red-200': '#FDC8C9',
  'red-300': '#FD9699',
  'red-400': '#FE4D59',
  'red-500': '#EF0731',
  'red-600': '#D10027',
  'red-700': '#AD001B',
  'red-800': '#8F0015',
  'red-900': '#6B0011',
  'red-950': '#460B0D',
}

export const greenColors = {
  'green-50': '#F7FDF7',
  'green-100': '#E7F9E9',
  'green-200': '#C6F1CB',
  'green-300': '#99E6A4',
  'green-400': '#5ECF6E',
  'green-500': '#2AAD3D',
  'green-600': '#068925',
  'green-700': '#00701A',
  'green-800': '#085915',
  'green-900': '#104714',
  'green-950': '#112D11',
}

export const limeColors = {
  'lime-50': '#F9FDF2',
  'lime-100': '#EAF9D2',
  'lime-200': '#D5F3AA',
  'lime-300': '#BAE97C',
  'lime-400': '#99D34F',
  'lime-500': '#6FB024',
  'lime-600': '#4B8505',
  'lime-700': '#3D6908',
  'lime-800': '#32540B',
  'lime-900': '#2B440D',
  'lime-950': '#1E2B0D',
}

export const blueColors = {
  'blue-50': '#F5F9FE',
  'blue-100': '#DAE9FC',
  'blue-200': '#CAE0FC',
  'blue-300': '#99C3FA',
  'blue-400': '#70A5F5',
  'blue-500': '#3A7CEE',
  'blue-600': '#3665D4',
  'blue-700': '#2146B5',
  'blue-800': '#203993',
  'blue-900': '#162964',
  'blue-950': '#111C4B',
}

// to be replaced
export const darkblueColors = {
  'darkblue-50': '#E9F1FE',
  'darkblue-100': '#D4E3FC',
  'darkblue-200': '#A8C6FA',
  'darkblue-300': '#7DAAF7',
  'darkblue-400': '#518DF5',
  'darkblue-500': '#2671F2',
  'darkblue-600': '#1555C2',
  'darkblue-700': '#0C3D91',
  'darkblue-800': '#082861',
  'darkblue-900': '#021430',
}

// to be replaced (only used in AppFeatureTag with gold-100 and gold-700)
export const goldColors = {
  'gold-50': '#FFF9EB',
  'gold-100': '#FFF3D6',
  'gold-200': '#FFE7AD',
  'gold-300': '#FFDA85',
  'gold-400': '#FFCE5C',
  'gold-500': '#FFC233',
  'gold-600': '#CC9A25',
  'gold-700': '#997218',
  'gold-800': '#664C0E',
  'gold-900': '#332606',
}

export const yellowColors = {
  'yellow-50': '#FFFAE5',
  'yellow-100': '#FCF4C4',
  'yellow-200': '#FEF0A4',
  'yellow-300': '#FDE277',
  'yellow-400': '#F8CE4E',
  'yellow-500': '#F2B21D',
  'yellow-600': '#D98F04',
  'yellow-700': '#A66907',
  'yellow-800': '#87530E',
  'yellow-900': '#6B4011',
  'yellow-950': '#362308',
}

export const orangeColors = {
  'orange-50': '#FFF8F0',
  'orange-100': '#FFEBD0',
  'orange-200': '#FFD49E',
  'orange-300': '#FFB86B',
  'orange-400': '#FF8B29',
  'orange-500': '#F56600',
  'orange-600': '#CC4D00',
  'orange-700': '#AD4100',
  'orange-800': '#8A3400',
  'orange-900': '#692A02',
  'orange-950': '#3F1B04',
}

// to be replaced (only used in SmartImportOptions with peach-50 and peach-500)
export const peachColors = {
  'peach-50': '#FFF5EF',
  'peach-100': '#FFEADF',
  'peach-200': '#FFD5BE',
  'peach-300': '#FFC09E',
  'peach-400': '#FFAB7D',
  'peach-500': '#FF965D',
  'peach-600': '#CC6C37',
  'peach-700': '#994A20',
  'peach-800': '#663113',
  'peach-900': '#331708',
}

export const indigoColors = {
  'indigo-50': '#F6F7FE',
  'indigo-100': '#E5E9F9',
  'indigo-200': '#D0D7F6',
  'indigo-300': '#B4BCEE',
  'indigo-400': '#8689DF',
  'indigo-500': '#5555CE',
  'indigo-600': '#4040B5',
  'indigo-700': '#36369B',
  'indigo-800': '#2B2B79',
  'indigo-900': '#22225E',
  'indigo-950': '#191948',
}

export const purpleColors = {
  'purple-50': '#F8F6FE',
  'purple-100': '#ECE9F9',
  'purple-200': '#DDD7F5',
  'purple-300': '#C6BAEE',
  'purple-400': '#A28AE0',
  'purple-500': '#7247C9',
  'purple-600': '#5F39AC',
  'purple-700': '#4F2C96',
  'purple-800': '#3D2079',
  'purple-900': '#2E1560',
  'purple-950': '#1F0F43',
}

export const pinkColors = {
  'pink-50': '#FEF6FA',
  'pink-100': '#FCE7F0',
  'pink-200': '#FBCFE3',
  'pink-300': '#F9A8CA',
  'pink-400': '#F373A6',
  'pink-500': '#EB4683',
  'pink-600': '#D23774',
  'pink-700': '#9E2454',
  'pink-800': '#7C1D42',
  'pink-900': '#5C1932',
  'pink-950': '#3D1522',
}

export const tealColors = {
  'teal-50': '#F7FDFC',
  'teal-100': '#DAF6F3',
  'teal-200': '#B1ECE7',
  'teal-300': '#77DAD5',
  'teal-400': '#45BFBE',
  'teal-500': '#29A3A3',
  'teal-600': '#078283',
  'teal-700': '#056F70',
  'teal-800': '#0D5959',
  'teal-900': '#134949',
  'teal-950': '#143434',
}

export const skyColors = {
  'sky-50': '#F5FAFE',
  'sky-100': '#E2F1FD',
  'sky-200': '#C6E3FB',
  'sky-300': '#CED6DE',
  'sky-400': '#50ABEC',
  'sky-500': '#178EE3',
  'sky-600': '#0079C7',
  'sky-700': '#005E9E',
  'sky-800': '#004B80',
  'sky-900': '#043C62',
  'sky-950': '#04263E',
}

export const violetColors = {
  'violet-50': '#FBF6FE',
  'violet-100': '#F2E3FC',
  'violet-200': '#E7CCFA',
  'violet-300': '#DDB7F5',
  'violet-400': '#C482ED',
  'violet-500': '#B159E4',
  'violet-600': '#973DCD',
  'violet-700': '#733399',
  'violet-800': '#5D297A',
  'violet-900': '#431E57',
  'violet-950': '#31183E',
}

export const baseColors = {
  ...greyColors,
  ...redColors,
  ...orangeColors,
  ...peachColors,
  ...yellowColors,
  ...goldColors,
  ...limeColors,
  ...greenColors,
  ...blueColors,
  ...darkblueColors,
  ...indigoColors,
  ...purpleColors,
  ...pinkColors,
  ...tealColors,
  ...skyColors,
  ...violetColors,
}

export const mainThemeColors = {
  'brand': baseColors['orange-500'],
  'transactional': baseColors['blue-500'],
  'dataroom': baseColors['purple-500'],
  'electronicsafe': baseColors['indigo-500'],
}

export const functionalColors = {
  'success': baseColors['green-500'],
  'info': baseColors['darkblue-500'],
  'warning': baseColors['yellow-500'],
  'error': baseColors['red-500'],
}

export const extraColors = {
  'red': baseColors['red-500'],
  'orange': baseColors['orange-500'],
  'yellow': baseColors['yellow-500'],
  'green': baseColors['green-500'],
  'blue': baseColors['blue-500'],
  'darkBlue': baseColors['darkblue-500'],
  'indigo': baseColors['indigo-500'],
  'purple': baseColors['purple-500'],
  'pink': baseColors['pink-500'],
  'peach': baseColors['peach-500'],
  'lime': baseColors['lime-500'],
  'gold': baseColors['gold-500'],
}

export const premiumColors = {
  'premium': baseColors['gold-500'],
}

export const vuetifyOverrideColors = {
  'primary': baseColors['grey-950'],
}

export const backgroundColors = {
  'bg-base': baseColors['grey-50'],
}

export const surfaceColors = {
  'surface-primary': baseColors['grey-0'],
  'surface-secondary': baseColors['grey-50'],
  'surface-tertiary': baseColors['grey-100'],

  'surface-inverted': baseColors['grey-950'],
  'surface-disabled': baseColors['grey-100'],

  'surface-brand-bold': baseColors['grey-950'],
  'surface-brand-bold-hover': baseColors['grey-900'],
  'surface-brand-bold-pressed': baseColors['grey-800'],
  'surface-brand': baseColors['grey-100'],
  'surface-brand-subtle': baseColors['grey-50'],

  'surface-info-bold': baseColors['sky-600'],
  'surface-info-bold-hover': baseColors['sky-700'],
  'surface-info-bold-pressed': baseColors['sky-800'],
  'surface-info': baseColors['sky-100'],
  'surface-info-subtle': baseColors['sky-50'],

  'surface-danger-bold': baseColors['red-600'],
  'surface-danger-bold-hover': baseColors['red-700'],
  'surface-danger-bold-pressed': baseColors['red-800'],
  'surface-danger': baseColors['red-100'],
  'surface-danger-subtle': baseColors['red-50'],

  'surface-warning-bold': baseColors['yellow-500'],
  'surface-warning': baseColors['yellow-100'],
  'surface-warning-subtle': baseColors['yellow-50'],

  'surface-success-bold': baseColors['green-600'],
  'surface-success': baseColors['green-100'],
  'surface-success-subtle': baseColors['green-50'],

  'surface-neutral-bold': baseColors['grey-600'],
  'surface-neutral': baseColors['grey-100'],
  'surface-neutral-subtle': baseColors['grey-50'],

  'surface-protege-bold': baseColors['purple-500'],
  'surface-protege': baseColors['purple-100'],
  'surface-protege-subtle': baseColors['purple-50'],

  'surface-orange-bold': baseColors['orange-600'],
  'surface-orange': baseColors['orange-300'],
  'surface-orange-subtle': baseColors['orange-100'],

  'surface-lime-bold': baseColors['lime-600'],
  'surface-lime': baseColors['lime-300'],
  'surface-lime-subtle': baseColors['lime-100'],

  'surface-teal-bold': baseColors['teal-600'],
  'surface-teal': baseColors['teal-300'],
  'surface-teal-subtle': baseColors['teal-100'],

  'surface-blue-bold': baseColors['blue-600'],
  'surface-blue': baseColors['blue-300'],
  'surface-blue-subtle': baseColors['blue-100'],

  'surface-indigo-bold': baseColors['indigo-600'],
  'surface-indigo': baseColors['indigo-300'],
  'surface-indigo-subtle': baseColors['indigo-100'],

  'surface-violet-bold': baseColors['violet-600'],
  'surface-violet': baseColors['violet-300'],
  'surface-violet-subtle': baseColors['violet-100'],

  'surface-pink-bold': baseColors['pink-600'],
  'surface-pink': baseColors['pink-300'],
  'surface-pink-subtle': baseColors['pink-100'],

  'surface-grey-bold': baseColors['grey-600'],
  'surface-grey': baseColors['grey-300'],
  'surface-grey-subtle': baseColors['grey-100'],
}

export const textColors = {
  'text-primary': baseColors['grey-950'],
  'text-secondary': baseColors['grey-900'],
  'text-tertiary': baseColors['grey-800'],
  'text-placeholder': baseColors['grey-600'],
  'text-disabled': baseColors['grey-400'],
  'text-inverted': baseColors['grey-0'],
  'text-info': baseColors['sky-700'],
  'text-danger': baseColors['red-600'],
  'text-warning': baseColors['yellow-900'],
  'text-success': baseColors['green-700'],
  'text-neutral': baseColors['grey-700'],
  'text-protege': baseColors['purple-600'],
  'text-link': baseColors['sky-600'],
  'text-link-hover': baseColors['sky-700'],
  'text-orange': baseColors['orange-700'],
  'text-lime': baseColors['lime-700'],
  'text-teal': baseColors['teal-700'],
  'text-blue': baseColors['blue-700'],
  'text-indigo': baseColors['indigo-700'],
  'text-violet': baseColors['violet-700'],
  'text-pink': baseColors['pink-700'],
  'text-grey': baseColors['grey-700'],
}

export const iconColors = {
  'icon-primary': baseColors['grey-700'],
  'icon-secondary': baseColors['grey-500'],
  'icon-disabled': baseColors['grey-400'],
  'icon-inverted': baseColors['grey-0'],
  'icon-info-bold': baseColors['sky-700'],
  'icon-info': baseColors['sky-500'],
  'icon-danger-bold': baseColors['red-600'],
  'icon-danger': baseColors['red-500'],
  'icon-warning-bold': baseColors['yellow-900'],
  'icon-warning': baseColors['yellow-500'],
  'icon-success-bold': baseColors['green-700'],
  'icon-success': baseColors['green-500'],
  'icon-neutral-bold': baseColors['grey-700'],
  'icon-neutral': baseColors['grey-500'],
  'icon-protege-bold': baseColors['purple-600'],
  'icon-protege': baseColors['purple-500'],
  'icon-link': baseColors['sky-600'],
  'icon-orange': baseColors['orange-700'],
  'icon-lime': baseColors['lime-700'],
  'icon-teal': baseColors['teal-700'],
  'icon-blue': baseColors['blue-700'],
  'icon-indigo': baseColors['indigo-700'],
  'icon-violet': baseColors['violet-700'],
  'icon-pink': baseColors['pink-700'],
  'icon-grey': baseColors['grey-700'],
}

export const borderColors = {
  'border-primary': baseColors['grey-200'],
  'border-secondary': baseColors['grey-300'],
  'border-secondary-hover': baseColors['grey-400'],
  'border-form': baseColors['grey-500'],
  'border-form-hover': baseColors['grey-400'],
  'border-disabled': baseColors['grey-200'],
  'border-inverted': baseColors['grey-900'],
  'border-info-bold': baseColors['sky-600'],
  'border-info': baseColors['sky-200'],
  'border-danger-bold': baseColors['red-600'],
  'border-danger': baseColors['red-200'],
  'border-warning': baseColors['yellow-200'],
  'border-success': baseColors['green-200'],
  'border-neutral': baseColors['grey-200'],
  'border-protege-bold': baseColors['purple-600'],
  'border-protege': baseColors['purple-200'],
  'border-orange': baseColors['orange-200'],
  'border-lime': baseColors['lime-200'],
  'border-teal': baseColors['teal-200'],
  'border-blue': baseColors['blue-200'],
  'border-indigo': baseColors['indigo-200'],
  'border-violet': baseColors['violet-200'],
  'border-pink': baseColors['pink-200'],
  'border-grey': baseColors['grey-200'],
}

export const aliasColors = {
  ...mainThemeColors,
  ...functionalColors,
  ...extraColors,
  ...premiumColors,
  ...vuetifyOverrideColors,
  ...backgroundColors,
  ...surfaceColors,
  ...textColors,
  ...iconColors,
  ...borderColors,
}

export const themeColors = {
  ...baseColors,
  ...aliasColors,
}

export type ThemeColors = keyof typeof themeColors
